import theme from '../styles/theme.mjs';

const DEFAULT_BREAKPOINT = 'default';
const buildResponsiveCSS = (property, value) => {
    if (!value) {
        return '';
    }
    if (Array.isArray(value)) {
        const [defaultValue, valueUpMd, valueUpLg] = value;
        let responsiveCSS = `
      ${property}: ${defaultValue};
    `;
        if (valueUpMd) {
            responsiveCSS += `
        @media screen and (min-width: ${theme.breakpoints.md}) {
          ${property}: ${valueUpMd};
        }
      `;
        }
        if (valueUpLg) {
            responsiveCSS += `
        @media screen and (min-width: ${theme.breakpoints.lg}) {
          ${property}: ${valueUpLg};
        }
      `;
        }
        return responsiveCSS;
    }
    if (typeof value === 'object' && !Array.isArray(value)) {
        return Object.entries(value).reduce((css, [breakpoint, breakpointValue]) => {
            const cssRule = `${property}: ${breakpointValue};`;
            if (breakpoint === DEFAULT_BREAKPOINT) {
                return css + cssRule;
            }
            const breakpointSize = theme.breakpoints[breakpoint];
            return css + `@media screen and (min-width: ${breakpointSize}) { ${cssRule} }`;
        }, '');
    }
    return `${property}: ${value};`;
};

export { buildResponsiveCSS };
//# sourceMappingURL=css.mjs.map
